import type { UserEntity } from '@sit/client-shared';
import { useCallback, useState } from 'react';
import LastStep from './LastStep';
import Step0WSUCredentials from './Step0WSUCredentials';
import Step1Sync from './Step1Sync';
import { Steps } from './steps';

function ProvisionTestContent() {
  const [step, setStep] = useState<(typeof Steps)[keyof typeof Steps]>(
    Steps.WSU_CREDENTIALS,
  );
  const [entities, setEntities] = useState<UserEntity[]>();
  const [companyTreeSettingsId, setCompanyTreeSettingsId] = useState<
    number | undefined
  >();

  const onSetWsuCredentialsSuccess = useCallback(
    ({
      entities: entitiesFromStep0,
      companyTreeSettingsId: cts,
    }: {
      entities: UserEntity[];
      companyId: string;
      companyTreeSettingsId: number;
    }) => {
      setCompanyTreeSettingsId(cts);

      setEntities(entitiesFromStep0);
      setStep(Steps.SYNC);
    },
    [],
  );

  const onSyncSuccess = useCallback(() => {
    setStep(Steps.LAST_STEP);
  }, []);

  switch (step) {
    case Steps.WSU_CREDENTIALS:
      return <Step0WSUCredentials onSuccess={onSetWsuCredentialsSuccess} />;
    case Steps.SYNC: {
      const entityIds = entities?.map((e) => e.id) ?? [];
      return (
        <Step1Sync
          entityIds={entityIds}
          onSuccess={onSyncSuccess}
          companyTreeSettingsId={companyTreeSettingsId!}
        />
      );
    }
    case Steps.LAST_STEP:
      return <LastStep />;
    default:
      return null;
  }
}

function ProvisionTest() {
  return (
    <div className="provision-content">
      <ProvisionTestContent />
    </div>
  );
}

export default ProvisionTest;
